// extracted by mini-css-extract-plugin
export var root = "K_wQ";
export var wrapper = "K_wR";
export var image = "K_wS d_w d_y d_W";
export var imageWithHeight = "K_wT";
export var crop = "K_wV";
export var round = "K_wW";
export var fixedHeight = "K_wX";